module.exports = __webpack_public_path__ + "static/img/comp.6b990887.png";